module.exports = __webpack_public_path__ + "components/weather-icon/static/nightpartcloud-da03df29f51e6b5fc71c9a1cca80cfee.svg";